/*
 * Purpose: Basic & Plus feature comparison — theme-aware cards above Stripe checkout
 * Last modified: 2026-07-01 | Agent
 * Completeness: 96
 */
import { Check } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { PRICING_PLANS } from '@/lib/pricingPlans';
import { cn } from '@/lib/utils';

export function PricingPlanFeatures() {
  return (
    <div className="grid gap-4 sm:gap-6 md:grid-cols-2 max-w-5xl mx-auto">
      {PRICING_PLANS.map((plan) => (
        <Card
          key={plan.id}
          className={cn(
            'border-border/70 bg-card/95 backdrop-blur-sm',
            plan.highlighted &&
              'ring-1 ring-[hsl(var(--ab-green-sage))] border-[hsl(var(--ab-green-sage))]/60 shadow-[var(--elev-shadow-rest)]'
          )}
        >
          <CardHeader className="pb-3 space-y-2">
            <div className="flex items-center justify-between gap-2">
              <CardTitle className="text-lg sm:text-xl text-foreground">{plan.name}</CardTitle>
              {plan.highlighted ? (
                <Badge className="bg-[hsl(var(--ab-green-core))] text-[hsl(var(--ab-ink-50))] hover:bg-[hsl(var(--ab-green-core))]">
                  Popular
                </Badge>
              ) : null}
            </div>
            <CardDescription className="text-sm leading-relaxed">{plan.tagline}</CardDescription>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2.5">
              {plan.features.map((feature) => (
                <li key={feature} className="flex items-start gap-2.5 text-sm text-foreground/90">
                  <span
                    className={cn(
                      'mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full',
                      plan.highlighted
                        ? 'bg-[hsl(var(--ab-green-mist))] text-[hsl(var(--ab-green-deep))]'
                        : 'bg-muted text-muted-foreground'
                    )}
                    aria-hidden
                  >
                    <Check className="h-3 w-3" strokeWidth={2.5} />
                  </span>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
